module.exports = __webpack_public_path__ + "img/avon-fighting-breast-cancer-08.18d3480a.jpg";